import { analyticsUtils } from 'utils/analytics-utils';
import * as region from 'common/constants/region-codes';
import { KITCHEN_PRICE_PDP_ELEMENT_BLOCK } from './kitchen-price-pdp-constants';

type GAProductInfo = {
  productName: string;
  productId: string;
  productPrice: number;
  productPrevPrice: null;
  productBelong: 'LeroyMerlin';
};

export const addToCartGAEvent = (productInfo: GAProductInfo, elementName: string, elementText: string) => {
  analyticsUtils.sendEvent('GA:clickButton', {
    elementBlock: KITCHEN_PRICE_PDP_ELEMENT_BLOCK,
    elementType: 'button',
    elementName,
    elementText,
    ...productInfo,
  });
};

export const navSlideClickGAEvent = (productInfo: GAProductInfo, elementText: string) => {
  analyticsUtils.sendEvent('GA:clickButton', {
    elementType: 'button',
    elementBlock: KITCHEN_PRICE_PDP_ELEMENT_BLOCK,
    elementName: 'mediaContent',
    elementText,
    ...productInfo,
  });
};

export const getServiceInstallationsPrice = (regionId: string) => {
  switch (regionId) {
    case region.KRASNODAR:
    case region.OMSK:
    case region.VOLGOGRAD:
    case region.YAROSLAVL:
    case region.KEMEROVO:
    case region.ULYANOVSK:
    case region.SARATOV:
    case region.KALININGRAD:
      return 6300;
    case region.SAMARA:
    case region.NOVOSIBIRSK:
    case region.UFA:
    case region.BARNAUL:
    case region.PENZA:
    case region.KOSTROMA:
    case region.PERM:
    case region.IVANOVO:
      return 5600;
    case region.ST_PETERSBURG:
    case region.TVER:
    case region.TULA:
    case region.KIROV:
    case region.PETROZAVODSK:
    case region.ARKHANGELSK:
    case region.KURSK:
      return 7700;
    case region.CHELYABINSK:
    case region.ORENBURG:
    case region.SARANSK:
    case region.ROSTOV_NA_DONU:
    case region.CHEREPOVETS:
    case region.LIPETSK:
      return 7000;
    case region.VORONEZH:
    case region.TOLYATTI:
    case region.NOVOROSSIYSK:
      return 6650;
    case region.EKATERINBURG:
    case region.RYAZAN:
      return 7350;
    case region.STAVROPOL:
    case region.VLADIKAVKAZ:
      return 5250;
    case region.KHABAROVSK:
    case region.VLADIVOSTOK:
      return 10500;
    case region.IRKUTSK:
    case region.KALUGA:
      return 8400;
    case region.MOSCOW:
    case region.KLIN:
    case region.NOGINSK:
    case region.NARO_FOMINSK:
      return 8862;
    case region.KRASNOYARSK:
      return 7504;
    case region.KAZAN:
      return 8750;
    case region.TYUMEN:
      return 7770;
    case region.NABEREZHNYE_CHELNY:
      return 7224;
    case region.NOVOKUZNETSK:
      return 5775;
    case region.N_NOVGOROD:
      return 8169;
    case region.IZHEVSK:
      return 5950;
    case region.PSKOV:
      return 6755;
    case region.SMOLENSK:
      return 6503;
    case region.SURGUT:
      return 6895;
    default:
      return 5000;
  }
};
